export default __webpack_public_path__ + "static/media/logo.fdfcab04.svg";